export interface Testimoni {
  text: string;
  author: {
    name: string;
    title: string;
    avatar: string;
  };
}

export const TESTIMONI_DURATION_SECOND = 6000;
